export function endsWith(subject: string, search: string) {
    return (
        subject.substring(subject.length - search.length, subject.length) ===
        search
    )
}
